import { Input as AntdInput } from "antd";
import { InputProps as AntdInputProps } from "antd/lib/input";
import React from "react";

export type MyInputProps = AntdInputProps;

export interface InputStaticMethods {
  TextArea: typeof AntdInput.TextArea;
  Search: typeof AntdInput.Search;
  Password: typeof AntdInput.Password;
  Group: typeof AntdInput.Group;
}

const InputPolyfill = React.forwardRef<any, MyInputProps>((props, ref) => {
  return <AntdInput ref={ref} {...props} />;
}) as React.ForwardRefExoticComponent<MyInputProps & React.RefAttributes<any>> &
  InputStaticMethods;

InputPolyfill.TextArea = AntdInput.TextArea;
InputPolyfill.Search = AntdInput.Search;
InputPolyfill.Password = AntdInput.Password;
InputPolyfill.Group = AntdInput.Group;

export default InputPolyfill;
